module.exports = __webpack_public_path__ + "static/media/subscriber-home-background-new.363292da.jpg";